import { useQuery } from '@tanstack/react-query';

import getProductQuotes from '../api/getProductQuotes';

const useProductQuotes = (id: string) => {
  const query = useQuery({
    queryKey: ['product-quotes', id],
    queryFn: async () => {
      const response = await getProductQuotes(id);

      return response.data;
    },
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0
  });

  return query;
};

export default useProductQuotes;
